import React, {useEffect} from "react";
import UserManagerPage from "./UserManagerPage";
import {useQuery} from "@apollo/client";
import {
    IonButton,
    IonCard,
    IonCardContent,
    IonCardHeader,
    IonCardTitle,
    IonIcon, IonLabel,
    IonLoading,
    IonSpinner
} from "@ionic/react";
import {pencilOutline, pencilSharp, readerOutline, readerSharp} from "ionicons/icons";
import {USER_GET_RULE_DATA_QUERY, USER_GET_RULES_QUERY} from "../../schemas/userManager";


const UserManagerRules: React.FC<any> = () => {

    const [selectedRule, setSelectedRule] = React.useState<number | undefined>(undefined);
    const {loading:rulesLoading, error:rulesError, data: rulesData} = useQuery(USER_GET_RULES_QUERY, {variables: {}});

    const {loading:ruleLoading, error:ruleError, data: ruleData} = useQuery(USER_GET_RULE_DATA_QUERY, {variables: {id: selectedRule}, skip: !selectedRule});

    const selectRule = async (ruleId: number) => {
        setSelectedRule(ruleId);
    };
    return (
        <UserManagerPage page={'rules'}>
            <IonLoading isOpen={rulesLoading} />
            {!rulesLoading && rulesData &&
                <div className="userManagerContent">
                    <IonButton size="small" color="light" routerLink={'/user-manager/create-rule'} routerDirection="forward">
                        <IonLabel>+ Add Rule</IonLabel>
                    </IonButton>
                    <table style={{width: '100%', marginTop: '20px'}}>
                        <tbody>
                        <tr>
                            <td style={{
                                verticalAlign: "top",
                                width: !ruleData && !ruleLoading ? '100%' : 'auto',
                                padding: "0px"
                            }}>
                                <p><b>Number of Rules:</b> {rulesData.getRules.length}</p>
                                <table style={{
                                        width: '100%',
                                    }} className="striped">
                                        <thead>
                                        <tr>
                                            <th style={{textAlign: 'left'}}>Name</th>
                                            <th style={{textAlign: 'left'}}>Details</th>
                                        </tr>
                                        </thead>
                                        <tbody>
                                        {rulesData && rulesData.getRules.map((rule: any) => {
                                            return (
                                                <tr key={'rule_' + rule.id} onClick={() => selectRule(rule.id)}>
                                                    <td>
                                                        <div style={{
                                                            marginRight: '20px',
                                                            display: "inline-block",
                                                            borderRadius: '20px',
                                                            backgroundColor: rule.color ? rule.color : '#990099',
                                                            color: 'white',
                                                            lineHeight: '40px',
                                                            height: '40px',
                                                            width: '40px',
                                                            textAlign: 'center',
                                                            verticalAlign: 'center'
                                                        }}>{rule.name.substr(0, 1)}</div>
                                                        {rule.name}
                                                    </td>
                                                    <td>
                                                        {rule.details}
                                                    </td>

                                                </tr>
                                            );
                                        })}
                                        </tbody>
                                    </table>
                            </td>
                            <td style={{width: '10px', padding: '0px'}}></td>
                            <td style={{
                                verticalAlign: "top",
                                width: !ruleData && !ruleLoading ? '0px' : '350px',
                                padding: '0px'
                            }}>

                                {ruleLoading &&
                                    <IonCard style={{
                                        display: 'inline-block',
                                        verticalAlign: 'top',
                                        margin: '0px',
                                        width: '100%', top:'0px', position: 'sticky'
                                    }}>
                                        <IonCardContent>
                                            <div style={{
                                                position: 'relative',
                                                width: '100%',
                                                height: '100%',
                                                lineHeight: '100%',
                                                verticalAlign: 'middle'
                                            }}>
                                                <IonSpinner style={{
                                                    position: 'sticky',
                                                    left: '50%',
                                                    top: '50%'
                                                }}></IonSpinner>
                                            </div>
                                        </IonCardContent>
                                    </IonCard>
                                }
                                {ruleData && !ruleLoading && ruleData.getRuleData &&
                                    <IonCard style={{
                                        display: 'inline-block',
                                        verticalAlign: 'top',
                                        margin: '0px',
                                        width: '100%', top:'0px', position: 'sticky'
                                    }}>
                                        <IonCardHeader style={{borderBottom: '1px solid #cccccc'}}>

                                            <IonCardTitle style={{float: 'left'}}>{ruleData.getRuleData.name}</IonCardTitle>

                                            <div style={{
                                                display: 'inline-block',
                                                verticalAlign: 'top',
                                                float: 'right'
                                            }}>
                                                <IonButton fill="clear" size="small" href={"/user-manager/edit-rule/" + ruleData.getRuleData.id}><IonIcon md={pencilOutline} ios={pencilSharp}></IonIcon></IonButton>
                                            </div>
                                            <div style={{clear: "both"}}></div>
                                        </IonCardHeader>
                                        <IonCardContent style={{padding:'10px'}}>

                                            <table style={{width: '100%'}}>
                                                <tbody>
                                                <tr>
                                                    <td rowSpan={2} style={{verticalAlign: 'top'}}>
                                                        <b><IonIcon md={readerOutline} ios={readerSharp}></IonIcon></b>
                                                    </td>
                                                    <td><b>Details:</b></td>
                                                </tr>
                                                <tr>
                                                    <td>
                                                        {ruleData.getRuleData.details}
                                                    </td>
                                                </tr>

                                                </tbody>
                                            </table>

                                        </IonCardContent>

                                    </IonCard>
                                }
                            </td>
                        </tr>
                        </tbody>
                    </table>
                </div>
            }


        </UserManagerPage>
    );
};


export default UserManagerRules;